import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { submitTemplate } from "../../../../utils/cookieConsentApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import TopBannerTemplateWidget from "../../../../components/Apps/CookieConsent/Template/TopBannerWidget";
import RightFloatingBoxTemplateWidget from "../../../../components/Apps/CookieConsent/Template/RightFloatingBoxWidget";
import CenterFloatingBoxTemplateWidget from "../../../../components/Apps/CookieConsent/Template/CenterFloatingBoxWidget";
import LeftFloatingBoxTemplateWidget from "../../../../components/Apps/CookieConsent/Template/LeftFloatingBoxWidget";
import BottomBannerTemplateWidget from "../../../../components/Apps/CookieConsent/Template/BottomBannerWidget";

//Import Tabs
import ContentTab from "../../../../components/Apps/CookieConsent/ContentTab";
import LayoutTab from "../../../../components/Apps/CookieConsent/LayoutTab";
import StyleTab from "../../../../components/Apps/CookieConsent/StyleTab";

export default function CreateCookieConsent() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Content");
    const [activeTemplateSection, setActiveTemplateSection] = useState("Top_Banner_Temp");
    const [selectedLayout, setSelectedLayout] = useState("top-banner-layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("top-banner.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Cookie Consent");
    const [newWidgetName, setNewWidgetName] = useState("");
    
    const [cookieConsentTabData, setCookieConsentTabData] = useState({
        is_website_frontend: "",  
        compliance_type: "",  
        language_type: "English",  
        message: "",  
        policy_display_type: "",       
        policy_url: "https://upgadeify.com",       
        policy_link_text: "Learn more",       
        allow_button_text: "Allow Cookies",       
        decline_button_text: "Decline",       
        postion_type: "top-banner-layout",       
        is_show_cookie_icon: 1,       
        is_show_confirmation_button: 1,       
        confirmation_button_text: "OK",       
        background_color: "",       
        text_color: "",       
        link_color: "",       
        allow_button_color: "",       
        decline_button_color: "",       
        confirmation_button_background_color: "",       
        text_font_size: "14px",       
        style_custom_css: "",       
        style_custom_js: "",       
    });

    // Set Template Setting And Texts when activeTemplateSection changes
        useEffect(() => {
            let compliance_type = "";
            let policy_display_type = "";
            let message = "";
            let confirmation_button_text = "";
            let background_color = "";
            let text_color = "";
            let link_color = "";
            let allow_button_color = "";
            let decline_button_color = "";
            let confirmation_button_background_color = "";
        
            switch (activeTemplateSection) {
                case "Top_Banner_Temp":
                    compliance_type = "Hide_Allow_Cookies";
                    policy_display_type = "Show_Policy_link";
                    message = "We use cookie to improve your experience on our site.";
                    confirmation_button_text = "OK"
                    background_color = "#031a4e";
                    text_color = "#fff";
                    link_color = "#fff";
                    allow_button_color = "#ffcd29";
                    decline_button_color = "#fff";
                    confirmation_button_background_color = "rgb(250, 179, 0)";
                    break;
                case "Right_Floating_Box_Temp":
                    compliance_type = "Show_Allow_Cookies";
                    policy_display_type = "Show_Policy_link";
                    message = "We use cookie to improve your experience on our site. By using our site you consent cookies.";
                    confirmation_button_text = "OK"
                    background_color = "#f6ebd6";
                    text_color = "#000";
                    link_color = "#000";
                    allow_button_color = "#000";
                    decline_button_color = "#000";
                    confirmation_button_background_color = "#fff";
                    break;
                case "Center_Floating_Box_Temp":
                    compliance_type = "Hide_Allow_Cookies";
                    policy_display_type = "Dont_Show_Policy_link";
                    message = "We use cookies to improve your experience on our site. By using our site you consent to cookies.";
                    confirmation_button_text = "OK"
                    background_color = "#fff";
                    text_color = "#000";
                    link_color = "#000";
                    allow_button_color = "#fff";
                    decline_button_color = "#000";
                    confirmation_button_background_color = "#fff";
                    break;
                case "Left_Floating_Box_Temp":
                    compliance_type = "Hide_Allow_Cookies";
                    policy_display_type = "Show_Policy_link";
                    message = "We use cookie to improve your experience on our site. By using our site you consent cookies. ";
                    confirmation_button_text = "OK"
                    background_color = "#fff";
                    text_color = "rgb(0 0 0)";
                    link_color = "#1c91ff";
                    allow_button_color = "#fff";
                    decline_button_color = "#000";
                    confirmation_button_background_color = "#fff";
                    break;
                case "Bottom_Banner_Temp":
                    compliance_type = "Hide_Allow_Cookies";
                    policy_display_type = "Show_Policy_link";
                    message = "We use cookie to improve your experience on our site.";
                    confirmation_button_text = "OK"
                    background_color = "#000";
                    text_color = "#fff";
                    link_color = "#fff";
                    allow_button_color = "#fff";
                    decline_button_color = "#fff";
                    confirmation_button_background_color = "#fff";
                    break;
                default:
                    compliance_type = "";
                    policy_display_type = "";
                    message = "";
                    confirmation_button_text = "";
                    background_color = "";
                    text_color = "";
                    link_color = "";
                    allow_button_color = "";
                    decline_button_color = "";
                    confirmation_button_background_color = "";
            }
        
            // Update setCookieConsentTabData state with the data
            setCookieConsentTabData((prevData) => ({
                ...prevData,
                compliance_type: compliance_type,
                policy_display_type: policy_display_type,
                message: message,
                confirmation_button_text: confirmation_button_text,
                background_color: background_color,
                text_color: text_color,
                link_color: link_color,
                allow_button_color: allow_button_color,
                decline_button_color: decline_button_color,
                confirmation_button_background_color: confirmation_button_background_color,
                
            }));
        
        }, [activeTemplateSection]);

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateCookieConsentTabData = (key, value) => {
        setCookieConsentTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = () => {
      setShowTemplateSelection(false);
      setIsSubmitting(false);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          setSelectedLayout(layoutTypeValue);
      } else {
          alert('Please select a template');
      }
  }; 

    // Handle Layout Change
    const handleLayoutChange = (e) => {
        setSelectedLayout(e.target.value);
    };

  const menuItems = [
      { key: "Content", icon: "content.png", label: "Content" },
      { key: "Layout", icon: "layout.png", label: "Layout" },
      { key: "Style", icon: "style.png", label: "Style" },
  ];

  // Handle Source Tab input change
  const handleActiveTemplateInputChange = (event) => {
      setActiveTemplateSection(event.target.value);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          const template_image = selectedRadio.dataset.template_image;
          setSelectedLayout(layoutTypeValue);
          setSelectedTemplateImage(template_image);
          updateCookieConsentTabData("postion_type", layoutTypeValue);
      } else {
          alert('Please select a template');
      }
  };

  //Submit Review data
  const submitForm = async (e) => {
      e.preventDefault();

      setIsSubmitting(true);
      try {
        // Collect data from refs
        const settingsArray = Object.entries(cookieConsentTabData).map(([key, value]) => ({
            setting_key: key,
            setting_value: value,
        }));

          // Collect data from refs
          const payload = {
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: selectedTemplateImage,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                app_type: "Cookie_Consent",
                settings: settingsArray,
          };
          
          //Api Call
          let api_response = await submitTemplate(payload);

          //Check Responce
          if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/cookie-consent');
                }, 2000); 
          } else {
              toast.error(api_response.message);
          }
      } catch (error) {
          toast.error('Oops Something Wrong. Please Try Again!' + error.message);
      } finally {
          setIsSubmitting(false);
      }
  };

  return (
    <>
      <div className="create-goole-reviews-all">
            <CheckCurrentPlan from_page={true} app_name="Cookie Consent" app_type="Cookie_Consent" app_slug="cookie-consent"/>
            {showTemplateSelection ? (
                <div className="create-goole-reviews-side">
                    <span>Select a template to start with</span>
                    <div className="card h-100">
                        <div className="label-box-flex">
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Top_Banner_Temp" data-layout_type="top-banner-layout" data-template_image="top-banner.png" checked={activeTemplateSection === "Top_Banner_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/cookie-consent/templates/top-banner.png`} alt="top-banner" />
                                    </div>
                                    <div className="content_sub">Top Banner</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Right_Floating_Box_Temp" data-layout_type="right-floating-box-layout" data-template_image="right-floating-box.png" checked={activeTemplateSection === "Right_Floating_Box_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/cookie-consent/templates/right-floating-box.png`} alt="right-floating-box" />
                                    </div>
                                    <div className="content_sub">Right Floating Box</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Center_Floating_Box_Temp" data-layout_type="center-floating-box-layout" data-template_image="center-floating-box.png" checked={activeTemplateSection === "Center_Floating_Box_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/cookie-consent/templates/center-floating-box.png`} alt="center-floating-box" />
                                    </div>
                                    <div className="content_sub">Center Floating Box</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Left_Floating_Box_Temp" data-layout_type="left-floating-box-layout"  data-template_image="left-floating-box.png" checked={activeTemplateSection === "Left_Floating_Box_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/cookie-consent/templates/left-floating-box.png`} alt="left-floating-box" />
                                    </div>
                                    <div className="content_sub">Left Floating Box</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Bottom_Banner_Temp" data-layout_type="bottom-banner-layout" data-template_image="bottom-banner.png" checked={activeTemplateSection === "Bottom_Banner_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/cookie-consent/templates/bottom-banner.png`} alt="bottom-banner" />
                                    </div>
                                    <div className="content_sub">Bottom Banner</div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="continue-template">
                        <button onClick={handleContinueTemplate}>Continue with this template</button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="overlay-side-baar">
                        <div className="side-baar-inner-one">
                            <ul>
                                {menuItems.map((item) => (
                                    <li key={item.key}>
                                        <button
                                            className={activeSection === item.key ? "active" : ""}
                                            onClick={() => setActiveSection(item.key)}
                                        >
                                            <img
                                                src={`${process.env.PUBLIC_URL}/cookie-consent/icons/${item.icon}`}
                                                alt={`${item.key} icon`}
                                            />
                                            <span>{item.label}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="side-baar-inner-tow">
                            {/* Conditional Rendering for Sections */}
                            {activeSection === "Content" && (
                              <ContentTab updateCookieConsentTabData={updateCookieConsentTabData} cookieConsentTabData={cookieConsentTabData} />
                            )}
                            {activeSection === "Layout" && (
                              <LayoutTab handleLayoutChange={handleLayoutChange} selectedLayout={selectedLayout} updateCookieConsentTabData={updateCookieConsentTabData} cookieConsentTabData={cookieConsentTabData} />
                            )}
                            {activeSection === "Style" && (
                              <StyleTab updateCookieConsentTabData={updateCookieConsentTabData} cookieConsentTabData={cookieConsentTabData}/>
                            )}
                        </div>
                    </div>
                </>
            )}
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/cookie-consent"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                        <div className="untitled-widget-name countdown-timer-icon">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/images/app-icon/cookie-consent.svg`} alt="cookie-consent"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={submitForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/cookie-consent/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/cookie-consent" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Cookie Consent <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Check template type*/}
                    {activeTemplateSection === "Top_Banner_Temp" && (
                      <TopBannerTemplateWidget selectedLayout={selectedLayout} updateCookieConsentTabData={updateCookieConsentTabData} cookieConsentTabData={cookieConsentTabData}/>
                    )}

                    {activeTemplateSection === "Right_Floating_Box_Temp" && (
                      <RightFloatingBoxTemplateWidget selectedLayout={selectedLayout} updateCookieConsentTabData={updateCookieConsentTabData} cookieConsentTabData={cookieConsentTabData}/>
                    )}

                    {activeTemplateSection === "Center_Floating_Box_Temp" && (
                      <CenterFloatingBoxTemplateWidget selectedLayout={selectedLayout} updateCookieConsentTabData={updateCookieConsentTabData} cookieConsentTabData={cookieConsentTabData}/>
                    )}

                    {activeTemplateSection === "Left_Floating_Box_Temp" && (
                      <LeftFloatingBoxTemplateWidget selectedLayout={selectedLayout} updateCookieConsentTabData={updateCookieConsentTabData} cookieConsentTabData={cookieConsentTabData}/>
                    )}

                    {activeTemplateSection === "Bottom_Banner_Temp" && (
                      <BottomBannerTemplateWidget selectedLayout={selectedLayout} updateCookieConsentTabData={updateCookieConsentTabData} cookieConsentTabData={cookieConsentTabData}/>
                    )}
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 